module.exports = __webpack_public_path__ + "img/album17_07.64222419.jpg";